const totalLength =  ''
export default {
    totalLength ,
}


// WEBPACK FOOTER //
// ./src/page/state/page.js